import { Component, Input, OnInit } from '@angular/core';
import { ComparatorsService, Ota, PanierService, TrackingService, WindowRefService } from '@app/core';
import { ICombineEngine, ILineV2 } from '@app/shared/interfaces';
import { chain } from 'lodash';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { incrementStockCombine } from '@app/state/general/app.actions';
import { MatDialog } from '@angular/material/dialog';
import { SnapshatComponent } from '../modals/snapshat/snapshat.component';

@Component({
    selector: 'app-price-match',
    templateUrl: './price-match.component.html',
    styleUrls: ['./price-match.component.scss']
})
export class PriceMatchComponent implements OnInit {
    @Input() engine: ICombineEngine;

    constructor(private winRef: WindowRefService, private panierService: PanierService, private store: Store<any>, private comparatorsService: ComparatorsService, private dialog: MatDialog, private trackingService: TrackingService) { }

    ngOnInit() {
    }

    addInCart() {
        this.store.dispatch(new incrementStockCombine({ combineIncremented: {}, indexSearch: this.engine.combine.indexSearch }));
    }

    /**
     * get taux de change
     * @returns number
     */
    get Cpercente(): number {
        return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
        return this.winRef.appConfigSite.Ccurrency;
    }

    /**
     * lang
     * @returns string lang
     */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

    openSnapshat(engine) {
        const dialogRef = this.dialog.open(SnapshatComponent, {
          data: {engine: engine},
          panelClass: 'snapshoot'
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log(`Dialog result: ${result}`);
        });
        this.trackingService.compare(null);
    }

    /**
     * has promo
     * @returns boolean has promo
     */
    get hasPromoIQ(): boolean {
        return this.winRef.appConfigSite.promo
    }

    get remise() {
        let remise = 100 - (this.prices.Ttc * 100 / this.engine.combine.detailPrice_without_promo.Ttc);
        return Math.round((remise * 100) / 100);
    }

    get prices() {
        return this.winRef.appConfigSite.promo ? this.engine.combine.detailPrice : this.engine.combine.detailPrice_without_promo
    }

}
